
export const NAME_REDUCER = 'user';

export const PREFIX_ACTIONS = 'user_feature_';

export const PATH_LOADING = {
  getHistoryClockInOut: `loading.${NAME_REDUCER}.getHistoryClockInOut`,
  getWaitingList: `loading.${NAME_REDUCER}.getWaitingList`,
  getBillWaitingTicket: `loading.${NAME_REDUCER}.getBillWaitingTicket`,
  getSummaryData: `loading.${NAME_REDUCER}.getSummaryData`,
  getListStaffAvailable: `loading.${NAME_REDUCER}.getListStaffAvailable`,
};

export const CHECK_IN_TYPES = {
  walkIn: 'WALK_IN',
  appointment: 'APPOINTMENT',
};

export const STAFF_CLOCK_IN_OUT_ACTIONS = {
  CLOCK_IN: 'CLOCK_IN',
  CLOCK_OUT: 'CLOCK_OUT',
};

export enum EMainLayout {
  FULL_STAFFS = 'FULL_STAFFS',
  GENERAL = 'GENERAL',
}

export enum EStaffListStatus {
  BUSY = 'BUSY',
  AVAILABLE = 'AVAILABLE',
}

export const STAFF_STATUS_CONFIG = {
  [EStaffListStatus.BUSY]: {
    bgColor: '#FF3B3B',
    label: 'Busy',
    boxShadow: '0 4px 12px rgba(255, 59, 59, 0.3)',
  },
  [EStaffListStatus.AVAILABLE]: {
    bgColor: '#35D39E',
    label: 'Available',
    boxShadow: '0 4px 12px rgba(53, 211, 158, 0.25)',
  }
};